import { hasChallengersPeril } from './hasChallengersPeril';

// Starting on October 29th 2024 (for US):
// This is retroactive for previous key
// Challenger's Peril now adds an additional 90 seconds to the timer of Mythic Keystones in addition to the 15 second death penalty.
export function affixIncreasedTimeMs(affixIds: (null | number)[]): number {
  return hasChallengersPeril(affixIds) ? 90000 : 0;
}
